import React from "react"
import { useSelector } from "react-redux"
import { Spin } from "antd"

export default function LoadingContainer({ children }) {
  const loadingStatus = useSelector((state) => state.auth.loading)

  return (
    <div
      style={{
        maxWidth: "100vw",
        height: "100vh"
      }}
    >
      {children}
      {loadingStatus ? (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1500
          }}
        >
          <div
            style={{
              width: "100vw",
              height: "100vh",
              backgroundColor: "#DDD",
              opacity: 0.7,
              zIndex: 100
            }}
          ></div>
          <div
            style={{
              width: "2%",
              height: "2%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 120
            }}
          >
            <Spin type="spin" color="#000" height="100%" width="100%" />
          </div>
        </div>
      ) : null}
    </div>
  )
}
